import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';

const formatMoney = (amount, currency) =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount || 0);

export const CurrencyBreakdownWidget = ({ data }) => {
  const summary = data?.summary;
  if (!summary?.by_currency || summary.by_currency.length <= 1) {
    return (
      <div
        className="border border-dashed border-slate-200 bg-slate-50 rounded-sm p-6 text-center"
        data-testid="widget-currency-breakdown-empty"
      >
        <p className="text-sm font-ibm text-slate-500">Add transactions in multiple currencies to enable this widget.</p>
      </div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="bg-slate-50 border border-slate-200 rounded-sm p-6"
      data-testid="widget-currency-breakdown"
    >
      <div className="flex items-center gap-2 mb-4">
        <Globe size={16} className="text-slate-600" />
        <h2 className="text-sm font-chivo font-bold text-slate-900 uppercase tracking-widest">By Currency</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {summary.by_currency.map((b) => (
          <div
            key={b.currency}
            className="bg-white border border-slate-200 rounded-sm p-4"
            data-testid={`widget-currency-card-${b.currency}`}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-ibm font-semibold uppercase tracking-widest text-slate-600">{b.currency}</span>
              <span className="text-xs font-ibm text-slate-500">{b.count} txns</span>
            </div>
            <div className="flex justify-between items-baseline">
              <span className="text-xs font-ibm text-slate-600">Profit</span>
              <span
                className={`text-lg font-chivo font-bold tabular-nums ${b.profit >= 0 ? 'text-emerald-600' : 'text-red-600'}`}
                data-testid={`widget-currency-profit-${b.currency}`}
              >
                {formatMoney(b.profit, b.currency)}
              </span>
            </div>
            <div className="flex justify-between items-baseline mt-1">
              <span className="text-xs font-ibm text-slate-500">+ Income</span>
              <span className="text-xs font-ibm text-emerald-600 tabular-nums">{formatMoney(b.income, b.currency)}</span>
            </div>
            <div className="flex justify-between items-baseline">
              <span className="text-xs font-ibm text-slate-500">- Expenses</span>
              <span className="text-xs font-ibm text-red-600 tabular-nums">{formatMoney(b.expenses, b.currency)}</span>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};
